import { styled } from 'baseui'

export const HintText = styled('div', {
  marginTop: '0.25rem',
  fontSize: '0.75rem',
  color: '#888',
  lineHeight: '1.4',
})

export const SuggestionLink = styled('span', {
  color: '#276EF1',
  cursor: 'pointer',
  textDecoration: 'underline',
  fontWeight: 500,
})
